import React, {useEffect, useState, useRef} from 'react';
import { Auth } from 'aws-amplify';
//import { useAuthenticator } from '@aws-amplify/ui-react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import StackPanel from './StackPanel';

import './LandingPage.css';
import './ui.css';

// https://ui.docs.amplify.aws/react/connected-components/authenticator/advanced#authentication-check

const LandingPage = () => {
  // const { user } = useAuthenticator((context) => [context.user]);
  const [ scrollX, setScrollX ] = useState(0);
  const mapRef = useRef();

  const goToApp = () => {
    window.location.href = "/app";
  }
  const goToServiceLandingPage = () => {
    window.location.href = "/info/service";
  }
  // if (user !== undefined) {
  //   goToApp();
  // }

  const scrollMap = () => {
    setScrollX(prev => prev - 1);
  }
  useEffect(() => {
    const id = setInterval(scrollMap, 50);
    return () => {
      clearInterval(id);
    }
  }, []);

  return (
    <>
      <div className="background-image" style={{transform: `translateX(${scrollX}px)`}}>
        <div className="background-image-row">
          <img ref={mapRef} src="/soccer-diagram-2.png" />
          <img ref={mapRef} src="/soccer-diagram-2.png" />
          <img ref={mapRef} src="/soccer-diagram-2.png" />
          <img ref={mapRef} src="/soccer-diagram-2.png" />
          <img ref={mapRef} src="/soccer-diagram-2.png" />
        </div>
      </div>

      <div className="fill">
        <StackPanel
          direction="t2b"
          anchor="top"
          alignItems="center"
          justifyContent="center"
          fillParent
        >
          <div style={{marginTop: '3vh'}}>
            <Box m={0} textAlign="center">
              <Typography variant="h5">Soccer Whiteboard</Typography>
            </Box>
          </div>

          <div style={{marginTop: '6vh'}}>
            {/* <Typography variant="h5">View, Share & Follow</Typography> */}
            <Typography variant="h5">&bull; Diagramming</Typography>
            <Typography variant="h5">&bull; Manage Rosters</Typography>
            <Typography variant="h5">&bull; Share & Export</Typography>
          </div>

          <div style={{marginTop: '2vh', zoom:1.4}}>
            <Box m={4}>
              <Button variant="contained" onClick={() => goToApp()}>Start</Button>
            </Box>
          </div>

          {/* {user === undefined && (
            <Box m={1}>
              <Button
                onClick={() => goToApp()}
              >
                New user?  Click to create your account
              </Button>
            </Box>
          )} */}

          {/* <Box m={3}>
            <Button
              onClick={() => goToServiceLandingPage()}
            >
              Service provider?  Learn more
            </Button>
          </Box> */}

        </StackPanel>
      </div>
    </>
  );
}

export default LandingPage;
